module.exports = __webpack_public_path__ + "static/media/cyclic.0c94fb94.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/cyclic.png
// module id = 51
// module chunks = 0